import React from "react";
import { Link } from "react-router-dom";
import { Path } from "../../Path.js";

import Header from "../../Global/Header";

export default function Mainbanner() {
  return (
    <>
      <div id="main_banner" className="container-fluid">
        <Header />
        <div className="row">
          <h2 className="heading main_banner-heading">
            Sharing your passion for
            <br /> finance, business and art.
          </h2>
          <p className="para-sub main_banner-para">
            Enter the world of billionaires and benefit from staking your NFT,
            earning <br />
            $LITTLE and MATIC on a daily basis and countless other utilities and
            benefits
          </p>

          <ul className="price-phrase main_banner-list main_banners">
            <li>
              <Link to="/little-token" className="whitepaper">
                <button className="custom-btn btn-banner header">
                  $LITTLE TOKEN
                </button>
              </Link>
            </li>
            <li>
              <a
                href={Path + "Whitepaper_FINAL_1.1-2.pdf"}
                target="_blank"
                className="whitepaper"
                rel="noreferrer"
              >
                <button className="custom-btn btn-banner header">
                  Whitepaper
                </button>
              </a>
            </li>
            <li onClick={() => window.open("https://discord.gg/7UD5mSxSSW")}>
              <button className="custom-btn btn-banner header discord-btn">
                Discord
              </button>
            </li>
          </ul>
        </div>

        <div className="row main_banner-row">
          <img alt="three-person" className="three-person" src={"images/new/2.png"} />
        </div>
      </div>
    </>
  );
}
